import cn from 'classnames'

import { IIconToggleProps } from './models/iconToggleProps'

import styles from './IconToggle.module.scss'

export const IconToggle = ({ isCollapsed, onClick }: IIconToggleProps) => {
  return (
    <div className={styles.root} onClick={onClick}>
      <i
        className={cn(styles.icon, 'kbase', {
          'kbase-omni-chevron-right': !isCollapsed,
          'kbase-omni-chevron-down': isCollapsed,
        })}
      />
    </div>
  )
}
